import React from 'react';
import { ArrowRightIcon, CalendarDaysIcon, ShoppingBagIcon, VideoIcon } from 'lucide-react';
import { schoolMedia } from '../../data/schoolContent';
import { Container } from '../ui/Container';
import { SectionTitle } from '../ui/SectionTitle';
import { ButtonLink } from '../ui/ButtonLink';
const resources = [{
  title: 'Class schedule',
  body: 'Find the right age group and plan your time on the mat.',
  href: '/schedule',
  label: 'See the schedule',
  icon: CalendarDaysIcon
}, {
  title: 'Events & school news',
  body: 'Tournament memories, school announcements and ways to get involved.',
  href: '/about-3',
  label: 'Explore school events',
  icon: CalendarDaysIcon
}, {
  title: 'Wear your Bates pride',
  body: 'Explore school shirts in black or red, with cotton and dry-fit options.',
  href: '/merch',
  label: 'Browse merchandise',
  icon: ShoppingBagIcon
}, {
  title: 'Practice your forms',
  body: 'Keep poomsae videos close by for practice between classes.',
  href: '/more',
  label: 'Watch poomsae videos',
  icon: VideoIcon
}];
export function SchoolLife() {
  return <>
    <section id="school-life" aria-labelledby="school-life-title" className="bg-white py-20 lg:py-28" data-id="element-317" data-mp="b53ihmv1hayu">
      <Container data-id="element-318" data-mp="k3fantbk0gte">
        <div className="flex flex-col gap-5 lg:flex-row lg:items-end lg:justify-between" data-id="element-319" data-mp="k2w0wzw24yqg">
          <SectionTitle id="school-life-title" data-id="element-320" data-mp="p28qhsebcjwq">More ways to be part of Bates</SectionTitle>
          <p className="max-w-[29rem] text-lg leading-relaxed text-muted" data-id="element-321" data-mp="u1lcyc19voys">From your weekly class to your next tournament, find the school information you need in one place.</p>
        </div>
        <div className="mt-10 grid gap-5 sm:grid-cols-2 xl:grid-cols-4" data-id="element-322" data-mp="y0u5xeohnita">{resources.map(item => <a key={item.href} href={item.href} className="group flex flex-col rounded border border-line bg-paper p-6 transition-colors hover:border-brand" data-id="element-323" data-mp="12vzy2v8hhtpt">
          <item.icon className="h-6 w-6 text-brand" aria-hidden="true" data-id="element-324" data-mp="1ct5py5ox9or3" />
          <h3 className="mt-6 font-display text-[1.75rem] font-bold uppercase leading-tight" data-id="element-325" data-mp="1hqxrlrfdcp8h">{item.title}</h3>
          <p className="mt-3 text-[15px] leading-relaxed text-muted" data-id="element-326" data-mp="s2imh7g3l3pj">{item.body}</p>
          <span className="mt-auto flex items-center gap-2 pt-6 text-sm font-semibold group-hover:text-brand" data-id="element-327" data-mp="n47bgte2gn5q">{item.label}<ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-328" data-mp="11td94cx9a5bi" /></span>
        </a>)}</div>
      </Container>
    </section>
    <section id="facility" aria-labelledby="facility-home-title" className="bg-paper py-20 lg:py-28" data-id="element-329" data-mp="x13l52fpbfbv">
      <Container className="grid items-center gap-10 lg:grid-cols-2 lg:gap-16" data-id="element-330" data-mp="1as8fbp0avfet">
        <img src={schoolMedia.trainingFloor} alt="Red and blue training mats inside the Bates Taekwondo facility" loading="lazy" className="aspect-[4/3] w-full rounded object-cover" data-id="element-331" data-mp="15v88vczjgan6" />
        <div data-id="element-332" data-mp="1fsw74cwcs0a3">
          <p className="mb-4 text-sm font-semibold uppercase tracking-[0.15em] text-brand" data-id="element-333" data-mp="1fscyxnwi8q99">2820 Richmond Dr NE · Albuquerque</p>
          <SectionTitle id="facility-home-title" data-id="element-334" data-mp="3mjm4c27yo7g4">A place to put in the work</SectionTitle>
          <p className="mt-6 text-lg leading-relaxed text-muted" data-id="element-335" data-mp="3hlau3qdr7uxd">Step inside the school for a look at the training floor, conditioning equipment and space where the Bates community practices together.</p>
          <div className="mt-8 flex flex-wrap items-center gap-5" data-id="element-336" data-mp="21zqj7yxtnw6j">
            <ButtonLink href="/the-bates-space" data-id="element-337" data-mp="1ncnfvbmtitba">Explore our facility</ButtonLink>
            <a href="/about-us" className="inline-flex min-h-[44px] items-center font-semibold underline decoration-brand decoration-2 underline-offset-4 hover:text-brand" data-id="element-338" data-mp="1saystv8etjxq">Our coaching philosophy</a>
          </div>
        </div>
      </Container>
    </section>
  </>;
}